import { put, takeEvery } from "@redux-saga/core/effects";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
	selectCreditTable: "[selectCreditTable] Action",
	selectCreditTableLoad: "[selectCreditTableLoad] Action",
	selectCreditTableAsync: "[selectCreditTableAsync] Action",
};

const initialState = {
	data: [],
	loading: false,
};

export const select_credit_active_table_reducer = (
	state = initialState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.selectCreditTable:
			return {
				...state,
				data: payload?.data?.results ? payload?.data?.results : [],
			};

		case actionTypes.selectCreditTableLoad:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({ type: actionTypes.selectCreditTableLoad, payload: true });
	let config = {
		url: "select_request",
	};

	let data = {
		table: "credit",
		method_type: "select_active_credit_plans",
		data: payload?.data ? payload?.data : {},
		sort_by: {},
		size: "50",
		from: "0",
	};

	try {
		let res = yield AxiosCustom(config, data);
		let isOk = handleNotificationAlertTrySelect(res);
		yield put({
			type: actionTypes.selectCreditTable,
			payload: res.data.response,
		});
	} catch {
		handleNotificationAlertCatch();
		// yield put({ type: actionTypes.creaditSelectLoad, payload: false });
	} finally {
		yield put({ type: actionTypes.selectCreditTableLoad, payload: false });
	}
}

export function* selectActiveTableCredit() {
	yield takeEvery(actionTypes.selectCreditTableAsync, handleWorker);
}
